module.exports = __webpack_public_path__ + "static/media/preview_customers.d039795b.PNG";